import React, { useEffect, useState, useRef } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import ModalUploader from "../../Componentes/FileUploader/modalUploader";
import ModalArquivosPlanejamento from "./modalArquivosPlanejamento";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import html2pdf from "html2pdf.js";
import { FaFileUpload, FaEye } from "react-icons/fa";
import iconPenta from '../../Imagens/icone_pentagrama.png';
import "./index.css";

const Planejamento = () => {
  const { IDProcesso, IDCliente } = useParams();
  const navigate = useNavigate();
  const { objClienteAberto } = usePentagovContext();
  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();

  const [perguntas, setPerguntas] = useState({});
  const [respostasEditadas, setRespostasEditadas] = useState({});
  const [clienteLogado, setclienteLogado] = useState();

  const [exibirUploader, setExibirUploader] = useState(false);
  const [exibirVisualizador, setExibirVisualizador] = useState(false);
  const [perguntaSelecionada, setPerguntaSelecionada] = useState(null);
  const [IDDiretorioPlanejamento, setIDDiretorioPlanejamento] = useState(null);
  const [bucketNamePlanejamento, setBucketNamePlanejamento] = useState(null);

  const [categoriaSelecionada, setCategoriaSelecionada] = useState("todas");
  const [gerandoPDF, setGerandoPDF] = useState(false);

  const planejamentoRef = useRef(null);
  const pdfRef = useRef(null);

  useEffect(() => {
    if (operador && authReady) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setclienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  async function inicializaTela() {
    try {
      const response = await api.get(`/planejamento/perguntas/${IDProcesso}`);
      setPerguntas(response.data || {});

      console.log("IDProcesso", IDProcesso);

      const diretorio = await api.get(`/diretorioByIDPai/${0}/${IDProcesso}`);
      console.log('diret', IDProcesso);
      setIDDiretorioPlanejamento(diretorio.data.diretorios[0].IDDiretorio);
      setBucketNamePlanejamento(diretorio.data.diretorios[0].nomeBucketAws);
    } catch (error) {
      console.error("Erro ao buscar perguntas:", error);
    }
  }

  const abrirUploader = (pergunta) => {
    setPerguntaSelecionada(pergunta);
    setExibirUploader(true);
  }

  const abrirVisualizador = (pergunta) => {
    setPerguntaSelecionada(pergunta);
    setExibirVisualizador(true);
  }

  const salvarRespostasCategoria = async (categoria) => {
    const perguntasCategoria = perguntas[categoria];

    const respostasParaSalvar = perguntasCategoria
      .filter((p) => (respostasEditadas[p.IDPlanejamento_perguntas] || "").trim() !== "")
      .map((p) => ({
        IDPlanejamento_perguntas: p.IDPlanejamento_perguntas,
        resposta: (respostasEditadas[p.IDPlanejamento_perguntas] || "").trim()
      }));

    if (respostasParaSalvar.length === 0) {
      alert("Nenhuma resposta preenchida para salvar.");
      return;
    }

    try {
      await api.put("/planejamento/perguntas/respostas", respostasParaSalvar); // adapte rota se necessário
      alert("Respostas salvas com sucesso.");
    } catch (error) {
      console.error("Erro ao salvar respostas:", error);
      alert("Erro ao salvar respostas.");
    }
  };

  const gerarPDF = () => {
    const element = pdfRef.current;

    const opt = {
      margin: 0.5,
      filename: `planejamento_${IDProcesso}_${categoriaSelecionada.replace(/\s+/g, '_').toLowerCase()}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save();
  };


  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior
          userId={String(IDOperador).padStart(6, "0")}
          userName={nome}
          cliente={clienteLogado}
        />

        <br />
        <h3>Planejamento Estratégico</h3>

        <Container
          className={`PerguntasPlanejamento mt-4 ${gerandoPDF ? 'pdf-mode' : ''}`}
          ref={planejamentoRef}
        >

          <Row className="mb-8 no-print">
            <Col md={6} className="text-start">
              <br />
              <Form.Label><strong>Filtrar por Secretaria:</strong></Form.Label>
              <Form.Select
                value={categoriaSelecionada}
                onChange={(e) => setCategoriaSelecionada(e.target.value)}
              >
                <option value="todas">Todas as Secretarias</option>
                {Object.keys(perguntas).map((categoria, idx) => (
                  <option key={idx} value={categoria}>
                    {categoria}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} className="text-end">
              <div className="mb-6" style={{ marginLeft: "30px" }}>
                <br /><br />
                <button className="btn btn-outline-dark" onClick={() => gerarPDF()}>
                  Gerar PDF
                </button>
              </div>
            </Col>
          </Row>

          {Object.keys(perguntas)
            .filter((categoria) =>
              categoriaSelecionada === "todas" ? true : categoria === categoriaSelecionada
            )
            .map((categoria, idx) => (

              <div key={idx} className="mb-5">
                <br />
                <h4 className="mb-3 border-bottom pb-2">{categoria}</h4>
                {perguntas[categoria].map((item) => (
                  <Card className="mb-3 shadow-sm" key={item.IDPlanejamento_perguntas}>
                    <Card.Body>
                      <Row>
                        <Col md={8}>
                          <Card.Title className="mb-2" style={{ fontWeight: "600", textAlign: "left" }}>
                            {item.pergunta}
                          </Card.Title>
                        </Col>
                        <Col md={4}>
                          <Row className="text-end no-print" id="botoes_img">
                            <Col md={6}>
                              <button className="btn btn-info fs-6 w-100 btn-planejamento-acao" style={{ justifyItems: 'center', alignItems: 'center' }} onClick={() => abrirVisualizador(item)}>
                                <FaEye style={{ marginRight: '15px' }} />
                                Visualizar
                              </button></Col>
                            <Col md={6}>
                              <button className="btn btn-info fs-6 w-100 btn-planejamento-acao" onClick={() => abrirUploader(item)}>
                                <FaFileUpload style={{ marginRight: '15px' }} />
                                Anexar
                              </button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="mb-2" style={{ textAlign: "left", fontSize: '14px' }}>
                        <Col md={6}><strong>Prazo:</strong> {item.prazo}</Col>
                        <Col md={6}><strong>Meta:</strong> {item.meta}</Col>
                      </Row>
                      <Row>
                        <Col md={8}>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="Digite sua resposta aqui"
                            className={
                              ((respostasEditadas[item.IDPlanejamento_perguntas] ?? item.resposta ?? "").trim() !== "")
                                ? "resposta-preenchida"
                                : ""
                            }
                            value={respostasEditadas[item.IDPlanejamento_perguntas] ?? item.resposta ?? ""}
                            onChange={(e) => {
                              const novaResposta = e.target.value;
                              setRespostasEditadas((prev) => ({
                                ...prev,
                                [item.IDPlanejamento_perguntas]: novaResposta,
                              }));
                            }}
                          />
                        </Col>
                        <Col md={4} className="d-flex align-items-center">
                          <div className="text-muted"><small><strong>Indicador de desempenho:</strong> {item.obs}</small></div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}
                <div className="text-end mt-3">
                  <button
                    className="btn btn-primary no-print"
                    onClick={() => salvarRespostasCategoria(categoria)}
                  >
                    Salvar Respostas
                  </button>
                </div>
              </div>
            ))}
          <br />
        </Container>
      </div >
      <ModalUploader
        show={exibirUploader}
        onClose={() => setExibirUploader(false)}
        pergunta={perguntaSelecionada}
        bucketName={bucketNamePlanejamento}
        tipoPermissao={operador?.permissaoPrincipal}
        IDDiretorio={IDDiretorioPlanejamento}
        permitirDocs={false}
        onUploadFinalizado={async (arquivos) => {
          if (!perguntaSelecionada?.IDPlanejamento_perguntas) return;

          try {
            for (const arquivo of arquivos) {
              await api.post("/planejamento/arquivo", {
                IDPlanejamento_perguntas: perguntaSelecionada.IDPlanejamento_perguntas,
                IDArquivo: arquivo.IDArquivo,
              });
            }

            console.log("Associação realizada com sucesso.");
          } catch (err) {
            console.error("Erro ao associar arquivos:", err);
            alert("Erro ao associar arquivos à pergunta.");
          }
        }}
      />
      <ModalArquivosPlanejamento
        show={exibirVisualizador}
        onClose={() => setExibirVisualizador(false)}
        pergunta={perguntaSelecionada}
        permissao={operador?.permissaoPrincipal}
        bucketName={bucketNamePlanejamento}
      />
      <div style={{ display: "none" }}>
        <div id="conteudo-pdf" ref={pdfRef} style={{ fontFamily: "Arial, sans-serif", padding: "20px", fontSize: "12px", color: "#333" }}>

          {/* Cabeçalho com logo e informações */}
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <img src={iconPenta} alt="Logo" style={{ height: "70px", marginBottom: "10px" }} />
            <p style={{ fontSize: "11px", color: "#555", margin: 0 }}>
              Pentagrama Auditoria e Consultoria Técnica Ltda
            </p>
            <p style={{ fontSize: "11px", color: "#555", margin: 0 }}>
              CNPJ nº 27.057.007/0001-04
            </p>
            <h4 style={{ marginTop: "15px", fontSize: "16px", fontWeight: "normal" }}>Planejamento Estratégico</h4>
            <p style={{ fontSize: "13px" }}>{clienteLogado}</p>
          </div>

          {/* Conteúdo de cada categoria */}
          {Object.keys(perguntas)
            .filter((categoria) =>
              categoriaSelecionada === "todas" ? true : categoria === categoriaSelecionada
            )
            .map((categoria, idx) => (
              <div key={idx} style={{ marginBottom: "35px" }}>
                <h5 style={{
                  textAlign: "center",
                  backgroundColor: "#f0f0f0",
                  padding: "8px 12px",
                  fontSize: "14px",
                  marginBottom: "20px",
                  borderRadius: "4px",
                  fontWeight: "normal"
                }}>
                  {categoria}
                </h5>

                {perguntas[categoria].map((item, i) => (
                  <div key={i} style={{
                    padding: "10px 15px",
                    marginBottom: "15px",
                    borderBottom: "1px solid #ccc"
                  }}>
                    <p style={{ marginBottom: "6px" }}><strong>Pergunta:</strong> {item.pergunta}</p>
                    <p style={{ marginBottom: "4px" }}><strong>Prazo:</strong> {item.prazo || "-"}</p>
                    <p style={{ marginBottom: "4px" }}><strong>Meta:</strong> {item.meta || "-"}</p>
                    <p style={{ marginBottom: "4px" }}><strong>Resposta:</strong> {(respostasEditadas[item.IDPlanejamento_perguntas] ?? item.resposta ?? "-").trim()}</p>
                    {item.obs && (
                      <p style={{ color: "#888", fontSize: "11px", marginTop: "6px" }}>
                        <strong>Indicador de desempenho:</strong> {item.obs}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>

    </div >
  );
};

export default Planejamento;
